// src/services/authService.ts
import api from "./axios";

export const getProfileData = async () => {
  return api.get("/users/profile");
};

interface profilePayload {
  name: string;
  interest_ids?: number[];
  cause_ids?: number[];
  bio?: string;
  city?: string;
  state?: string;
  country?: string;
  zip?: string;
}

export const updateUserProfile = async (data: profilePayload) => {
  return api.put("/users/profile", data);
};

export const getInterests = async () => {
  return api.get("/interests");
};

export const getCauses = async () => {
  return api.get("/causes");
};

export const getAddressData = async () => {
  return api.get("/users/address");
};

interface addressPayload {
  city: string;
  state: string;
  country: string;
  zip: string;
}

export const updateUserAddress = async (data: addressPayload) => {
  return api.post("/users/address", data);
};

interface changePasswordPayload {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export const changeUserPassword = async (data: changePasswordPayload) => {
  return api.post("/users/change-password", data);
};

export const getTransactionsData = async () => {
  return api.get("/users/transactions");
};
